export const COURSE_LIST_ALL_REQUEST = "COURSE_LIST_ALL_REQUEST";
export const COURSE_LIST_ALL_SUCCESS = "COURSE_LIST_ALL_SUCCESS";
export const COURSE_LIST_ALL_FAIL = "COURSE_LIST_ALL_FAIL";

export const COURSE_FILTER_LIST_REQUEST = "COURSE_FILTER_LIST_REQUEST";
export const COURSE_FILTER_LIST_SUCCESS = "COURSE_FILTER_LIST_SUCCESS";
export const COURSE_FILTER_LIST_FAILED = "COURSE_FILTER_LIST_FAILED";
